import {Injectable} from '@angular/core';
import {Translation, TranslocoLoader} from '@jsverse/transloco';

@Injectable({providedIn: 'root'})
export class TranslocoHttpLoader implements TranslocoLoader {
  async getTranslation(lang: string): Promise<Translation> {
    return fetch(`/assets/i18n/${lang}.json`).then(async (res) => res.json());
  }
}
